<template>
  <div class="info-mation">
    <ul>
      <li
        @click="oncheckLi(item)"
        :class="checkLi==item.value?'li-l check-li':'li-l'"
        v-for="(item,index) in liList"
        :key="index"
      >
        {{item.name}}
        <van-badge v-if="isBage==item.value" color="#FFF8EA" :content="messageCount" max="99" />
      </li>
    </ul>
    <div class="data-list">
      <system v-if="checkLi=='system'" :checkLi="checkLi"></system>
      <business v-if="checkLi=='business'" :checkLi="checkLi"></business>
      <activity v-if="checkLi=='activity'" :checkLi="checkLi"></activity>
    </div>
  </div>
</template>

<script>
import URLTB from "@/api/apiTB";
import Activity from './activity.vue'
import Business from './business.vue'
import system from './system.vue'
export default {
  components: { system, Business, Activity },
  
  data() {
    return {
      liList: [
        { name: '系统通知', value: 'system' },
        { name: '业务通知', value: 'business' },
        { name: '活动通知', value: 'activity' }
      ],
      checkLi: 'system',
      isBage: 'system',//徽标显示
      messageCount: ''
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      let that = this
      let data = {
        userId: localStorage.getItem('userid'),
        typeCode: that.checkLi,//system系统消息,business业务,activity活动
        page: 1,
        size: 10
      }
      that.$fetchGet(URLTB.getMessage.url, data).then(res => {
        if (res.data.code == 20000) {
          that.messageCount = res.data.data.unread
        }

      })
    },
    // nav切换
    oncheckLi(item) {
      this.checkLi = item.value
      this.isBage = item.value
      this.page = 1
      this.getData()
    },
    //改变消息状态 是否已读
    changeStatus(id){
      let data={
        userId:localStorage.getItem('userid'),
        msgId:id
      }
      this.$fetchPost(URLTB.messageStatus.url,this.$toFormData(data)).then(res=>{
        if(res.data.code==20000){
          this.getData()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.info-mation {
  height: 100vh;
  font-family: Source Han Sans CN;
  font-size: 14px;
  color: #333333;
  ul {
    display: flex;
    .li-l {
      width: 125px;
      height: 35px;
      line-height: 35px;
      text-align: center;
      background: url("../../assets/publicImg/li-bg1.png") no-repeat 50%;
      // background: url('./img/bg1.png') no-repeat 100%;
      background-size: 100% 100%;
      font-weight: 400;
      position: relative;
      .van-badge {
        position: absolute;
        top: 3px;
        right: 3px;
        color: #fc6e09;
      }
    }
    .check-li {
      background: url("./img/bg.png") no-repeat 50%;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .data-list {
    height: calc(100vh - 35px);
    overflow: scroll;
  }
}
</style>